import type { ImageLoaderProps } from "next/image";

/**
 * Deliver appropriately sized public Supabase Storage images without invoking
 * Vercel Image Optimization. Original object URLs remain unchanged in the DB.
 * Only URLs from our configured Supabase project are transformed.
 * Note: Supabase may bill image transformations separately; monitor usage.
 */
export function supabaseResponsiveLoader({ src, width, quality }: ImageLoaderProps): string {
  try {
    const url = new URL(src);
    const projectUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
    if (!projectUrl || url.origin !== new URL(projectUrl).origin) return src;

    const publicPrefix = "/storage/v1/object/public/";
    if (!url.pathname.startsWith(publicPrefix)) return src;

    url.pathname = url.pathname.replace(publicPrefix, "/storage/v1/render/image/public/");
    url.searchParams.set("width", String(width));
    url.searchParams.set("quality", String(Math.min(85, quality ?? 75)));
    url.searchParams.set("resize", "contain");
    return url.toString();
  } catch {
    return src;
  }
}
